import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import UserSession from '../models/session/user-session.entity';
import storageService from './storage.service';
import tokenRefreshService from './token-refresh.service';

const http = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 30000,
});

const redirectToLogin = () => {
  window.location.assign('/login');
};

http.interceptors.request.use(
  (axiosRequestConfig: AxiosRequestConfig): AxiosRequestConfig => {
    const mySession: UserSession = storageService.getObject('session')
      ? new UserSession(storageService.getObject('session'))
      : new UserSession();

    if (mySession.accessToken) {
      /* eslint no-param-reassign: "error" */
      axiosRequestConfig.headers.Authorization = `Bearer ${mySession.accessToken}`;
    }

    return axiosRequestConfig;
  },
);

http.interceptors.response.use(
  (axiosResponse: AxiosResponse) => axiosResponse,
  async (axiosError: AxiosError): Promise<any> => {
    const request: any = axiosError.config;
    const status = axiosError.response?.status;

    if (status === 401 && request && !request._retry) {
      request._retry = true;
      try {
        const newToken = await tokenRefreshService.refresh();
        request.headers = {
          ...request.headers,
          Authorization: `Bearer ${newToken}`,
        };
        return await http(request);
      } catch (refreshError) {
        redirectToLogin();
        return Promise.reject(axiosError);
      }
    }

    if (status === 403) {
      redirectToLogin();
    }

    return Promise.reject(axiosError);
  },
);

export default http;
